import ptBr from './ptBr';

export const resources = { ptBr };
